// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LatestContent__wrapper__1Ac1H","latestItem":"LatestContent__latestItem__ZkPoX","latestItemVideo":"LatestContent__latestItemVideo__3Uutn"};